<template>
  <div>
    <div
      v-if="activityIsValid"
      class="activity-container"
      :style="{
        backgroundColor: pageConfig.backgroundColor,
        paddingTop: `${paddingTop}px`,
      }"
      :class="showCustomBars&&'show_bars'"
      ref="activityContainer"
    >
      <template v-for="(item, index) in pageComponentList">
        <component
          :is="getComponentNameByType(item.type)"
          :key="index"
          :pageConfig="pageConfig"
          :componentConfig="item"
          :intention="intention"
          :isLock.sync="isLock"
          :ref="isDeliveryComponent(item.type) ? 'deliveryComponents' : null"
          @goQuestionSet="applyQuestionSet"
          @scrollToFirstDeliveryComponent="scrollToFirstDeliveryComponent"
          @showJbsCardPopup="showJbsCardPopup"
        />
      </template>

      <EmptyJobStatus v-if="emptyJobStatus" />

      <JobQuestionEntryPopup
        :visible.sync="questionPopupVisble"
        :jobNames="questionJobNameList"
        @goQuestionInfoPage="goQuestionInfoPage"
      />
      <!--51组件-->
      <JbsApplyJob ref="applyJobRef" v-bind="applyJobProps" />
      <!-- 无简历浮层 -->
      <!-- <NoResumeDiv v-if="!isApp && noResume" ref="noResumeDivRef" /> -->
      <!--  登录悬浮 -->
      <activity-login :loginConfig="loginConfig" v-if="showLoginPopup&&!showCustomBars" />
      <div class="scroll-tip" @click="handleScrollTop"></div>
      <!-- <div class="bottom_tip" v-if="pageComponentList?.length > 0">
        暂时没有更多了～
      </div> -->
      <!-- ai助手组件 -->
      <!-- <div>
        <img
          @click="goAi()"
          class="ai_into"
          src="@/assets/img/activity/ai/ai.png"
          alt=""
        />
      </div> -->
      <!-- 关注引导弹窗 -->
      <SubscribePopup
        :pageConfig="pageConfig"
        ref="subscribePopupRef"
      />
      <!-- 天降好职弹窗 -->
      <job-opportunity v-if="pageConfig?.popupConfigDTO?.jobOpportunity"  :pageConfig="pageConfig"></job-opportunity>
      <!-- 职位挽留弹窗 -->
      <job-retention-pop v-if="pageConfig?.popupConfigDTO?.jobRetention" :pageConfig="pageConfig" :showPop.sync="showJobRetention"></job-retention-pop>
      <!-- 常用地址弹窗 -->
      <nearby-pop :pageConfig="pageConfig"></nearby-pop>
    </div>
    <div v-else>
      <activity-empty :prevLink="prevLink" :countDown="countDown" />
    </div>
    <!-- 底部自定义引导 -->
    <activity-bars v-if="showCustomBars" :pageConfigId="pageConfig.id" :customGuideList="pageConfig.customGuideList" :buttonColor="pageConfig.buttonColor"></activity-bars>
    <!-- 显示大卡 -->
    <!-- 职位大卡 -->
     <JbsCardPopup
        v-if="JbsCardProps.show"
        v-bind="JbsCardProps"
        @handleExposureJobList="testHandleExposureJobList"
        @closePopup="closePopup"
        @handleJobDelivered="handleJobDelivered"
      />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import api from "@/utils/api";
import { getCityDictData } from "@51job/jbs-components-apis";
import QuestionAndAnswerList from "./QuestionAndAnswerList.vue";
import ActivityBars from "@/components/ActivityBars/index.vue";
import JobOpportunity from "@/components/JobOpportunity/index.vue"
import JobRetentionPop from "@/components/JobRetentionPop/index.vue"
import NearbyPop from "@/components/Nearby/NearbyPop.vue"
import EmptyJobStatus from "@/components/EmptyJobStatus/index.vue"
import CustomizedMulticolumnJobList from "@/components/CustomizedMulticolumnJobList/index.vue"
import JbsCardPopup from '@51job/jbs-bigcard-component/lib/JbsCardPopup';
import cupid from "@/utils/cupid";
import young from "@/utils/young";
import common from "@/utils/common.js";
// import ActivityBar from '@51job/jbs-bigcard-component/lib/ActivityBar.js';
export default {
  name: "activityIndex",
  components: {
    QuestionAndAnswerList,
    ActivityBars,
    JobOpportunity,
    JobRetentionPop,
    NearbyPop,
    EmptyJobStatus,
    CustomizedMulticolumnJobList,
    JbsCardPopup
  },
  data() {
    return {
      currentStep: 1,
      showTitle: false,
      showBack: false,
      bgColor: "",
      bgFilter: false,
      isTabbar: false, //是否为底部tabbar打开的页面
      isweChat: false, //是否是微信
      userGroup: "", // 用户群体 1：本科 2：专科
      // 学历信息-专业&学校
      educationDTO: {
        major: "",
        majorString: "",
        schoolName: "",
      },
      // 求职意向
      intention: {
        expectArea: "", //城市Code
        expectAreaString: "", //城市String
        expectFunction: "", //职能Code
        expectFunctionString: "", //职能String
        expectIndustry: "", //期望行业code
        expectIndustryNew: "", //期望新行业code
        minSalary: "", // 期望薪资下限
        maxSalary: "", // 期望薪资上限
      },
      area: "", // 地区，求职意向地区优先，否则使用居住地
      floorConfigList: [], //楼层配置
      hasShownSubPopup: false,
      comJobList: [], //客户职位弹框职位列表
      // 以下为此次新增参数
      loading: false,
      pageConfig: {},
      headerComponentConfig: {},
      pageComponentList: [],
      activityIsValid: true,
      effectStatus: "2",
      prevLink: "",
      loginConfig: {},
      hiddenHeader: false,
      paddingTop: 0,
      cityList: [],
      questionPopupVisble: false,
      questionJobIdList: [],
      questionJobNameList: "",
      isLock: false,
      hasBarData: false,
      showPcWideScreen: false,
      isPcScreen: false,
      deWeightType:[1,3,2,15,21],//需要职位去重的组件type值
      showJobRetention:false,//是否显示职位挽留弹窗
      emptyJobStatus: false,
      JbsCardProps: { //职位大卡详情信息
      // cupid: api.cupid,
        // young: api.young,
        // vapi: api.vapi,
        
        jobData: {},
        storeData: {},
        
        cupid: {
          post: cupid.post,
          get: cupid.getNew,
          delete: cupid.del
        },
        young: {
          post: young.post,
          get: young.getNew,
          delete: young.del
        },
        sensors: {
          track: this.$sensors.track,
          quick: this.$sensors.quick
        },
        show: false,
        zIndex: 2004
      },
      bigJobCardList:[],//大卡曝光过的职位
    };
  },
  computed: {
    ...mapState(["commonStore"]),
    ...mapState("applyJobStore", [
      "applyJobSignal",
      "applyOptions",
      "batchApplyJobSignal",
      "batchApplyOptions",
      "applied",
    ]),
    ...mapGetters("resumeStore", ["resumeId"]),
    countDown() {
      return !this.activityIsValid;
    },
    isForPC(){
      return this.commonStore.isForPC
    },
    // isPcScreen(){
    //   // 处理PC端显示样式
    //   const isMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent);
    //   return !isMobile && this.commonStore.fromdomain.includes('web');
    // },
    platform() {
      return this.commonStore.platform;
    },
    isApp() {
      return this.$store.getters.isApp;
    },
    showLoginPopup() {
      let needLogin_platform = ["51jobM", "51jobPC", "yjsM", "yjsPC"].includes(
        this.platform
      ); //需要登录的平台
      let loginGuide = this.loginConfig.loginGuide == "1"; //引导到登录页 1-开启
      let jumpGuide = this.loginConfig.jumpGuide == "1"; // 引导跳转 1-开启
      let outsidePlatforms =
        ["51jobWX", "51jobPC", "yjsWX", "yjsPC"].indexOf(this.platform) == -1; //不属于这里列举的平台
      let outHarmony = ["harmonyApp", "harmony"].indexOf(this.commonStore.device) == -1; // 判断是否在鸿蒙环境
      let isForPC = this.showPcWideScreen&&this.isPcScreen
      let searchPage = this.commonStore.searchPage
      return (
        //搜索结果页不显示
        !searchPage &&
        // 鸿蒙环境下不显示
        outHarmony &&
        // 开启宽屏且浏览器web下不显示
        !isForPC && (
          // 未登录-需要登录-需要引导登录页
          (!this.isLogin && needLogin_platform && loginGuide) ||
          // 不需要引导登录页 or 需要引导&&已登录
          ((!loginGuide || (loginGuide && this.isLogin)) &&
            // 引导跳转&&非app&&非
            jumpGuide &&
            !this.isApp &&
            outsidePlatforms)
        )
      );
    },
    showCustomBars(){
      // 搜索结果页不显示
      let searchPage = this.commonStore.searchPage
      // 适配宽屏不显示
      let wideScreen = this.showPcWideScreen&&this.isPcScreen
      // 有引导数据才显示
      let hasBarData = this.hasBarData
      return !searchPage && !wideScreen && hasBarData
    },
    applyJobProps() {
      let appType = null;
      if (this.commonStore.platform.includes("51job")) {
        appType = "51job";
      }
      if (this.commonStore.platform.includes("yjs")) {
        appType = "yjs";
      }
      return {
        cupid: api.cupid,
        young: api.young,
        vapi: api.vapi,
        appType: appType,
      };
    },
    areaCode() {
      return this.commonStore?.intention?.expectArea;
    },
    noResume() {
      // return true;
      return !this.resumeId;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
    /**
     *v0402:岗位类组件包括：职位列表双列+标签，岗位列表【单双列】，公司列表，logo墙，好职专区,职位列表（多列+滑动）
     */
     isDeliveryComponent(){
      return function(type){
        //投递类组件
        return [17,7,15,1,3,2,21].includes(type);
      }
     },
     is51Job() {
        console.log("平台用户信息",this.$store.getters.platform);
        return this.$store.getters.platform.indexOf("51job") !== -1 ;
      },
  },
  watch: {
    $route(to, from) {
      if (to.params.pageId) {
        location.reload()
      }
      
    },
    "commonStore.countJobAndCompany": {
      handler(data) {
        console.log(data , '【调试代码】只有职位或公司组件');
        this.emptyJobStatus = data === 0 ? true : false
      }
    },
    applyJobSignal() {
      if (this.isApp) {
        // app 内
        this.$refs.applyJobRef.applyJob(this.applyOptions);
      } else {
        if (this.noResume) {
          // this.$refs.noResumeDivRef.open({
          //   variant: "apply",
          // });
          this.$toast.clear();
          this.$toast.fail("投递失败，请先完善简历");
          return;
        }
        // console.log('edu', this.educationDTO);
        this.$refs.applyJobRef.applyJobH5({
          ...this.applyOptions,
          resumeId: this.resumeId,
          onFail: this.onApplyH5Fail,
        });
      }
    },

    batchApplyJobSignal() {
      //  无简历拦截
      if (this.noResume) {
        this.$toast.clear();
        this.$toast.fail("投递失败，请先完善简历");
        return;
      }
      this.$refs.applyJobRef.batchApplyJobH5({
        ...this.batchApplyOptions,
        resumeId: this.resumeId,
        onFail: this.onApplyH5Fail,
      });
    },
    showLoginPopup(newVal) {
      // 监听——埋点相关
      if (newVal) {
        if (
          this.isLogin ||
          (!this.isLogin && this.loginConfig?.loginGuide !== 1)
        ) {
          if (this.loginConfig?.jumpGuide === 1) {
            if (this.loginConfig?.jumpPlatform === 1) {
              this.$sensors.track("WidgetShow", {
                $element_id: "sensor_bcop_guide",
                contentType: "去app",
              });
            } else if (this.loginConfig?.jumpPlatform === 2) {
              this.$sensors.track("WidgetShow", {
                $element_id: "sensor_bcop_guide",
                contentType: "去小程序",
              });
            }
          }
        } else {
          if (this.loginConfig?.loginGuide == 1 && !this.isLogin) {
            this.$sensors.track("WidgetShow", {
              $element_id: "sensor_bcop_guide",
              contentType: "登录",
            });
          }
        }
      }
    },
  },
  async created() {
    this.commonStore.accountId&&this.getAddresses()
    this.$store.commit("setValueLocalStorage", {
      activityId: this.$route.params.pageId,
    });
    this.loading = true;
    await this.init();
    const queryData = {
      city: this.$route.query.areaCode,
      func: this.$route.query.funcCode,
    };
    sessionStorage.setItem(
      this.$route.params.pageId,
      JSON.stringify(queryData)
    );
  },
  async mounted() {
    console.log('用户信息',this.$store.state.commonStore.identityType,this.$store.state.commonStore.accountId,this.is51Job,this.$store.getters.device,this.$store.getters.fromdomain,this.commonStore.platform);
    // 标记特殊状态页面（与searchPage分离，按照需求后续可以拓展）
    // -1：无特殊  0：隐藏返回按钮
    const specialPage = this.$route.query.hideBackButton ? 0 : -1;
    this.$store.commit("setValueLocalStorage", {
      specialPage
    });

    this.$store.commit("setValueLocalStorage", {
      searchPage: this.$route.query.hideBackButton&&this.$route.query.hideFooter,
    });
    sessionStorage.removeItem("filterJobIds");
    sessionStorage.removeItem("exposuredJobIds");
    const elementDom = document.getElementById("skeleton_qs");
    elementDom && elementDom.remove(); // 移除骨架屏
    // 暴露打开弹窗方法
    this.$EventBus.$on('goBackIntercept',this.goBackIntercept);
    this.pcScreen();
  },
  beforeDestroy() {
     this.$EventBus.$off('goBackIntercept',this.goBackIntercept);
  },
  methods: {
    ...mapActions("operationStore", ["getResumeInfo", "checkResume"]),
    ...mapActions("resumeStore", ["loadBestResume"]),
    ...mapMutations(["setIntention", "setCurrentAreaCode","setExpandCityList"]),
    addQueue() {
      if (this.queueLoading) {
        console.log('【调试代码】正在加载组件');
        return
      }

      if (this.pageComponentList.length == this.queueComponentList.length) {
        console.log('【调试代码】两个数组长度一致，不再添加新组件--------------');
        try {
          window.removeEventListener('scroll', this.scrollHandler)
        } catch(error) {
          console.log(error)
        }
        return
      }
      
      const list = [...this.pageComponentList]
      console.log('【调试代码】添加一个新组件');
      this.queueLoading = true
      
      
      const component = list.splice(this.queueIndex, 1)
      
      if (component[0]) {
        this.queueComponentList = [...this.queueComponentList, component[0]]
        this.queueIndex++
      }

      const nowList = this.queueComponentList.map(list => {
        return list.type
      })
      console.log(nowList , '【调试代码】queueComponentList-type-list');
      
    },
    addQueueEventBus() {
      console.log('【调试代码】存在为空组件EventBus');
      this.queueLoading = false
      this.addQueue()
    },
    queueFinished() {
      this.queueLoading = false
    },
    scrollHandler() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const windowHeight = window.innerHeight || document.documentElement.clientHeight
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      )
      
      const distanceToBottom = documentHeight - (scrollTop + windowHeight)
      
      // 当距离底部小于等于50px时触发方法
      if (distanceToBottom <= 50) {
        this.addQueue()
      }
    },
    async init() {
      const res = await getCityDictData();
      // 过滤
      this.cityList = res.items.filter(
        (item) =>
          item.title !== "全国" &&
          item.title !== "国外" &&
          item.title !== "一线/新一线" &&
          item.title !== "二线城市"
      );
      if (this.isLogin) {
        const result = await this.getIntention();
        if (!result) await this.getDefaultCity();
        await this.getCrossCityList()
        await this.loadBestResume(); // 获取最佳简历
      } else {
        await this.getDefaultCity();
      }
      this.getActivityConfig();
    },
    pcScreen () {
      // 处理PC端显示样式
      const isMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent);
      this.isPcScreen =  !isMobile && this.commonStore.fromdomain.includes('web');
    },
    //获取附近经纬度
    async getAddresses() {
      const res = await this.$api.activity.getAddresses();
      if (res && res.status == "1") {
        if(res.resultbody.items.length>0){
          let address = res.resultbody.items[0]
          const [lon, lat] = address.lonLat.split(',');
          // 输出结果
          console.log("lon:", lon);
          console.log("lat:", lat);
          this.$store.commit("setValueLocalStorage", {
            lon: lon,
            lat: lat,
            radius: address.radius,
          });
        }else{
          this.$store.commit("setValueLocalStorage", {
            lon: '',
            lat: '',
            radius: '',
          });
        }
        
      }
    },
    // 获取页面配置信息
    getActivityConfig() {
      const params = {
        pageId: this.$route.params.pageId,
        isPreview: !!this.$route.query.preview,
        personAsLabel: this.$store.getters.personAsLabelModify,
        // busBelong: this.platform.indexOf("yjs") > -1 ? "应届生" : "51Job",
      };
      this.$api.activity.getActivityConfig(params).then((res) => {
        this.loading = false;
        if (res?.code == "0" && res?.data) {
          const currentAreaCode = this.$store.getters.currentAreaCode;
          const data = res.data;
          this.showPcWideScreen = res.data?.showPcWideScreen;
          res.data?.showPcWideScreen && this.adaptForPC()
          // TODO
          // this.showPcWideScreen =true;
          // this.adaptForPC()


          this.$store.commit("setValueLocalStorage", {
            nearbyPopShow: res.data?.popupConfigDTO?.commonAddressPopup==1&&!this.commonStore?.lon,
          });
          let {
            id, // 活动ID
            pageComponentList, // 活动页面对应的组件信息列表
            defaultCity, // 默认城市code
            activeCityList, // 活动城市数组列表，空数组表示不限
            activityName, // 活动页名称
            backgroundColor, // 背景色
            titleColor, // 活动标题色
            hideColor, // 上滑遮挡色
            buttonColor, // 按钮颜色
            activityIsValid, // true是有效   false是无效
            headIconUrl, // 头部图片url
            headIconPcUrl,
            moduleIconUrl, // 组件背景图片地址
            moduleIconPcUrl,
            prevLink, // 返回链接
            shareDescription, // 分享描述内容
            shareIcon, // 分享图片地址
            shareTitle, // 分享标题
            subtitle, // 副标题
            title, // 页面标题
            jobIconUrl, // 更多职位背景图
            customBackground, // 自定义背景
            effectStatus, // 生效状态：1-草稿；2-生效/启用；3-暂停；4-结束
            loginGuide, // 引导到登录页 1-开启
            loginText, // 登录引导文案
            jumpGuide, //引导跳转 1-开启
            jumpPlatform, //跳转平台 1-app 2-小程序
            jumpText, //引导跳转文案
            jumpLink, //引导跳转链接
            showCitySelector, // 是否显示城市选择器
            busBelong, // 业务归属：51job-51Job；yjs-应届生
            shareOfficialAccounts, // 分享公众号。如果 业务归属是51job，值为：前程无忧 51Job服务号；业务归属是应届生，值为：应届生求职服务号
            activityCreatorId,
            activityIntroduction,
            showJobSync,
            activityZoneId,
            activityZoneTitle,
            auditTime,
            calendarReminderDTO,
            customGuideList,
            popupConfigDTO, // 弹窗
            recommendConfigDTO,//推荐相关配置项
            showJobCard,//显示大卡
            showLatestUpdates, // 是否显示最新动态  1-是 0-否
          } = data;
          // console.log('=====data',id, customGuideList)
          // console.log('=====customGuideList--底部悬浮层', customGuideList)
          // console.log('=====data----所有配置信息', data)
          console.log('=====pageComponentList----组件信息列表', pageComponentList)
          !pageComponentList && (pageComponentList = []);
          // if (!activityIsValid) {
          //   this.$base.goHome(prevLink);
          // }

          this.loginConfig = {
            loginGuide,
            loginText,
            jumpGuide,
            jumpPlatform,
            jumpText,
            jumpLink,
          };
          this.activityIsValid = activityIsValid;
          this.prevLink = prevLink;
          this.effectStatus = effectStatus;

          if (currentAreaCode) {
            if (activeCityList?.length > 0) {
              let item = activeCityList?.find((n) => n === currentAreaCode);
              if (!item) {
                this.setCurrentAreaCode(defaultCity);
              }
            }
          }

          if (title) {
            document.title = title;
            localStorage.setItem("title", title);
          }
          // 活动信息
          this.pageConfig = {
            id,
            backgroundColor,
            titleColor,
            hideColor,
            buttonColor,
            moduleIconUrl,
            moduleIconPcUrl,
            jobIconUrl,
            customBackground,
            lastComponentId:
              pageComponentList[pageComponentList.length - 1]?.id,
            showCitySelector,
            busBelong,
            shareOfficialAccounts,
            showJobSync,
            activityZoneId:activityZoneId?activityZoneId:'',
            activityName,
            activityZoneTitle,
            showLatestUpdates,
            customGuideList,
            popupConfigDTO,
            prevLink,
            recommendConfigDTO,
            showJobCard
          };
          this.hasBarData = customGuideList?.length>0
          if (
            pageComponentList.length &&
            pageComponentList[0].type == 6 &&
            customBackground === 2
          ) {
            this.hiddenHeader = true;
          } else {
            this.hiddenHeader = false;
          }
          if (pageComponentList.length && customBackground === 2) {
            if (pageComponentList[0].type == 6) {
              this.paddingTop = 0;
            } else {
              this.paddingTop = 44;
            }
          } else {
            this.paddingTop = 0;
          }
          // 处理：如果活动页只有职位或公司楼层且无数据时，显示无职位引导
          if (pageComponentList.length) {
            const typeList = [1, 2, 3, 7, 21]

            const awaysJobAndCompany = () => {
              return pageComponentList.every((com) => typeList.includes(com.type))
            }

            if (awaysJobAndCompany()) {
              this.$store.commit("setValueLocalStorage", {
                countJobAndCompany: pageComponentList.length
              });
            }
          }

          const headerComponent = {
            type: "-1",
            headIconUrl,
            headIconPcUrl,
            activeCityList,
            defaultCity,
            prevLink,
            shareDescription,
            shareIcon,
            shareTitle,
            subtitle,
            title,
            hiddenHeader: this.hiddenHeader,
          };
          this.headerComponentConfig = headerComponent;

          this.$store.commit("setValueLocalStorage", {
            shareConfig: {
              shareDescription,
              shareIcon,
              shareTitle,
            },
          });

          this.$store.commit("setValueLocalStorage", {
            activityZoneId: activityZoneId ? activityZoneId : ''
          });

          const findItem = pageComponentList.find(item => [1, 3, 17, 21].includes(item.type));
          const promoJobIdSort = findItem ? findItem.sort : -1;
          this.$store.commit("setValueLocalStorage", {
            promoJobIdSort
          });
          
          if (activityCreatorId) {
            const createrComponent = {
              type: "0",
              activityCreatorId,
              activityIntroduction,
            };
            this.pageComponentList = [
              headerComponent,
              createrComponent,
              ...pageComponentList,
            ];
          } else {
            this.pageComponentList = [headerComponent, ...pageComponentList];
          }
          // 职位去重，先赋值第一个组件的顺序值
          this.$nextTick(()=>{
            let sortNum = 0;
            //自定义多列组件不在pageComponentList中，故单独处理
            this.pageComponentList.map(item =>{
              if(this.deWeightType.indexOf(item.type) != -1){//有需要去重职位的组件返回，赋值首次加载的去重组件
                sortNum ++;
                item.deWeightSort = sortNum;
                // 初始赋值
                if(sortNum == 1){
                  this.$store.commit("setValue", {
                    deweightComponentSort: sortNum,
                  });
                  console.log("触发初始化去重顺序值",this.$store.state.commonStore.deweightComponentSort);
                }
              }
            })
          })

          const pageId = this.$route.params.pageId;
          const exceptId = 1888825820176502786
          // const exceptId = 1910266370311315457

          //如果有日历配置，在头图与一楼之间插入日历
          if(calendarReminderDTO && JSON.stringify(calendarReminderDTO) !== '{}'){
            let calendarComponent = {
              type: "-2",
              auditTime,
              ...calendarReminderDTO
            }
            this.pageComponentList.splice(1,0,calendarComponent);//在头图与一楼之间插入日历

            if( activityZoneId && this.isLogin && pageId!=exceptId ){
              //  判断是否有订阅ID
              let customComponent = {
                type: "22",
                auditTime,
                showLatestUpdates
              }
              this.pageComponentList.splice(2,0,customComponent);//在头图与一楼之间插入自定义多列表滚动组件
            }
          }else {
            if( activityZoneId && this.isLogin && pageId!=exceptId ){
            //  判断是否有订阅ID
            let customComponent = {
              type: "22",
              auditTime,
              showLatestUpdates
            }
            this.pageComponentList.splice(1,0,customComponent);//在头图与一楼之间插入自定义多列表滚动组件
          }
          }
          
          this.$base.pageShareInit({
            shareImg: shareIcon,
            shareTitle: shareTitle,
            shareText: shareDescription,
            postImage: shareIcon,
            shareUrl: window.location.href,
          });
          const queryCity = this.$route.query.areaCode;
          if (queryCity) {
            let cityArr = this.cityList.reduce((prev, next) => {
              return prev.concat(next.items);
            }, []);
            if (activeCityList?.length > 0) {
              let items = [];
              this.cityList.forEach((item) => {
                if (item.title !== "热门城市") {
                  item.items.forEach((sItem) => {
                    if (activeCityList.includes(sItem.code)) {
                      items.push(sItem);
                      return;
                    }
                  });
                }
              });
              cityArr = items;
            }
            const hasCity = cityArr.find((item) => item.code == queryCity);
            if (hasCity) {
              this.setCurrentAreaCode(queryCity);
            }
          }

          if (this.activityIsValid && this.$route.query.subscribe !== '1' && !this.commonStore.nearbyPopShow) { 
            // url包含subscribe=1，触发自动关注，绕过信息采集
            // nearbyPopShow，绕过离家近弹框
            this.initQuestionSet(); // 前往信息采集的弹窗
          }

          // 左右滑动返回
          if (data?.swipeToReturn == 0 && this.isApp) {
            this.swiperLeftRight()
          }
        } else {
          this.$toast.fail({ message: res?.message });
        }

        // 初始化神策
        common.sensorsInitAfterQuery();

      });
    },

    adaptForPC () {
      if (this.showPcWideScreen && this.isPcScreen) {
        // 获取<html>元素
        var htmlElement = document.documentElement;
        // 使用classList的add方法为<html>元素添加一个新的类名
        htmlElement.classList.add('adapt_pc_widescreen');
        this.$store.commit("setValueLocalStorage", {
          isForPC: true,
        });
      }else{
        this.$store.commit("setValueLocalStorage", {
          isForPC: false,
        });
      }
    },
    // 获取求职意向
    async getIntention() {
      let intention = null;
      //51job求职意向列表
      if (this.commonStore.platform.includes("51job")) {
        const res = await this.$api.user.get51JobIntentions({
          isEnglish: false,
        });
        if (res && res.status == 1) {
          const items = res.resultbody.items || [];
          if (items.length > 0) {
            const obj = res.resultbody.items[0];
            intention = {
              expectArea: obj.expectArea || "",
              expectAreaString: obj.expectAreaString || "",
              expectFunction: obj.expectFunction || "",
              expectFunctionString: obj.expectFunctionString || "",
              expectIndustry: obj.expectIndustry || "",
              expectIndustryNew: obj.expectIndustry || "",
              minSalary: obj.minSalary, // 期望薪资下限
              maxSalary: obj.maxSalary, // 期望薪资上限
              seekType: obj.seekType,
            };
          }
        }
      } else {
        const res = await this.$api.user.getYJSIntentions({
          isEnglish: false,
        });
        if (res && res.status == 1) {
          // const expectAreas = res.resultbody.expectArea.items || [];
          const expectFuncs = res.resultbody.expectFunc.items || [];
          if (expectFuncs.length > 0) {
            const expectArea_obj = res.resultbody.expectArea.items[0];
            const expectFunc_obj = res.resultbody.expectFunc.items[0];
            const seekType = res.resultbody.jobTerm?.code;
            intention = {
              expectArea: expectArea_obj.expectArea || "",
              expectAreaString: expectArea_obj.expectAreaString || "",
              expectFunction: expectFunc_obj.expectFunc || "",
              expectFunctionString: expectFunc_obj.expectFuncString || "",
              expectIndustry: "",
              expectIndustryNew: "",
              minSalary: 0, // 期望薪资下限
              maxSalary: 0, // 期望薪资上限
              seekType: seekType || "",
            };
          }
        }
        console.log(intention, "11111111111111111");
      }
      if (intention) {
        this.intention = intention;
        this.setIntention(intention);
        return true;
      } else {
        return false;
      }
    },

    // 获取当前定位城市
    async getDefaultCity() {
      const res = await this.$api.user.getDefaultCity({
        isEnglish: false,
      });
      if (res.status === "1" && res.resultbody) {
        this.setCurrentAreaCode(res.resultbody.code);
      }
    },
    // 获取跨城引导所有的城市信息/值得投城市榜单
    async getCrossCityList() {
      const res = await this.$api.activity.getCrossCityList();
        if (res?.status == "1" && res.resultbody) {
          // 3-家乡、4-曾经就业城市、5-母校城市、6-同行必去城市
          // expectCity-期望城市, hometownCity-家乡城市,employmentCity-曾就业城市,almaMaterCity-母校城市,peerCities-同行必去城市
          const map = { 3: 'hometownCity', 4:'employmentCity',5:'almaMaterCity', 6: 'peerCities'}
          const result = {};
          // 遍历 map 对象
          Object.values(map).forEach(key => {
            if (res.resultbody.hasOwnProperty(key)) {
                const value = res.resultbody[key];
                if (Array.isArray(value)) {
                    // 如果是数组，直接赋值
                    result[key] = (value || []).map(item => item.code).join(',');
                } else if (typeof value === 'object' && value!== null) {
                    // 如果是对象，包装成数组
                    result[key] = ([value] || []).map(item => item.code).join(',');
                }
            }
        });
          this.setExpandCityList(result);
        }else {
          this.setExpandCityList(null);
        }
      
    },

    onApplyH5Fail({ status, message }) {
      console.log(status, "status", message, "message");
      // 简历信息不全
      // if (status === "-30") {
      //   // 投递前已保证有简历 id

      //   this.$toast({
      //     type: "fail",
      //     message,
      //     forbidClick: true,
      //     onClose: () => {
      //       // this.jumpResumeIndex();
      //     },
      //   });
      // }
    },
    handleScrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    async applyQuestionSet(jobList) {
      const jobIdList = jobList.map((item) => item.jobId);
      const params = {
        accountId: this.commonStore.accountId,
        jobIdList: jobIdList,
      };
      const res = await this.$api.activity.getSendResumeCollectDataQuery(
        params,
        {}
      );

      if (res.code == "0") {
        if (res.data.dataList && res.data.dataList.length != 0) {
          this.$store.commit("setValueLocalStorage", {
            jobQuestionSets: res.data,
          });
          this.goQuestionInfoPage(1);
          return;
        }
      }

      this.$toast.success({
        message: "投递成功",
        forbidClick: true,
        icon: this.successImg,
      });
    },
    async initQuestionSet() {
      if (!this.commonStore.accountId) {
        return;
      }
      const params = {
        accountId: this.commonStore.accountId,
      };
      const res = await this.$api.activity.popWindowCollectDataQuery(
        params,
        {}
      );

      if (res.code == "0") {
        if (res.data.dataList && res.data.dataList.length != 0) {
          this.questionJobNameList = res.data.dataList
            .map((item) => item.jobName)
            .join("");
          this.questionPopupVisble = true;
          this.$store.commit("setValueLocalStorage", {
            jobQuestionSets: res.data,
          });
        }
      }
    },
    goQuestionInfoPage(source) {
      const q = this.$route.query;
      this.$router.push({
        name: "DataCollectionPages",
        query: { ...q, source: source },
      });
    },
    goBackIntercept(typeName) { //返回挽留弹窗场景
      if(typeName == 'jobRetention'){//职位挽留弹窗
        this.showJobRetention = true;
      }else{
        this.$refs.subscribePopupRef.open({ variant: typeName });
      }
    },
    swiperLeftRight() {
      if (!localStorage.getItem(`${this.$route.params.pageId}_appswiper`)) {
        localStorage.setItem(`${this.$route.params.pageId}_appswiper`, true)
        window.location.reload()
      }

      window.onGestureBackClick = () => {
        this.$EventBus.$emit('handleBackEvent')
        return 1
      }
    },
    /**
     * v0402
     * 如果当前页面有岗位类组件，投递类激励任务点击去投递时页面滚动到第一个组件位置，如果当前页面无岗位类组件点击去投递不做任何操作
     * 岗位类组件包括：职位列表双列+标签，岗位列表【单双列】，公司列表，logo墙，好职专区,职位列表（多列+滑动）
     * 
     */
     scrollToFirstDeliveryComponent() {
      this.$nextTick(() => {
        const deliveryComponents = this.$refs.deliveryComponents;
        if (!deliveryComponents || deliveryComponents.length === 0) return;
        
        const firstComponent = deliveryComponents[0];
        const element = firstComponent.$el || firstComponent;
        
        // 更精确的滚动定位
        const elementRect = element.getBoundingClientRect();
        const offsetPosition = elementRect.top + window.pageYOffset;
        let headerHeight = this.isForPC ? 0 : 44 + 60; //44:头部高度 48：组件背景高度
        const scrollToPosition = offsetPosition - headerHeight;
        console.log('scrollToPosition1',scrollToPosition);
        console.log('头部高度2',headerHeight);

        
        window.scrollTo({
          top: scrollToPosition,
          behavior: 'smooth'
        });
      });
    },
    // 职位大卡展示
    showJbsCardPopup(index,titleName,urgentJobList,onSuccess) {
      console.log("显示大卡",index,titleName,urgentJobList);
      // 大卡传参变化
      if(!this.isApp){
        this.JbsCardProps.cupid = api.cupid,
        this.JbsCardProps.young = api.young,
        this.$set(this.JbsCardProps,'vapi',api.vapi);
        console.log("vapi",this.JbsCardProps.vapi,typeof(this.JbsCardProps.vapi));
      }
      const buildJobs = jobList =>
        jobList.map(item => {
          const property = JSON.parse(item.property);
          let exrInfoObj = {
            isFullJobCard: '是',
          };
          return {
            id: item.jobId,
            sensors: {
              pageCode: property.pageCode, // 外部模块pageCode值
              shortPageCode: property.pageCode, // 同上
              requestId: property.requestId || '', // 每个模块接口requestId
              policyId: property.policyId || '',
              advId: '', // 默认为空
              fromModule: '职位详情页投递',
              exrInfo: exrInfoObj
            }
          };
        });
      let floorJobsList = {
        1:{
          title: titleName || '', //职位大卡名称,
          jobs: buildJobs(urgentJobList || []),
        }
      };
      this.$set(this.JbsCardProps, 'jobData', {
        index: index,
        data: [...Object.values(floorJobsList)]
      });
      this.$set(this.JbsCardProps, 'storeData', {
        identityType: this.$store.state.commonStore.identityType || '',
        projectType: this.is51Job?'job':'yjs',
        device: this.$store.getters.device,
        isH5:(this.platform.includes("App") || this.platform.includes("PC")) ? false:true,
        isWX:this.platform.includes("WX"),
        isNewApply:true,
        noResume:this.noResume,
        resumeId:this.resumeId,
        accountid: this.$store.state.commonStore.accountId,
        frompageUrl: '',
        from_domain: this.$store.getters.fromdomain|| '',
      });
      this.$set(this.JbsCardProps,"deliverSuccess",onSuccess);
      this.$set(this.JbsCardProps, 'show', true);
    },
    //职位大卡关闭
    closePopup() {
      this.$set(this.JbsCardProps, 'show', false);
    },
    //职位大卡投递后同步卡片投递状态
    handleJobDelivered(item) {
      console.log("投递成功了",item);
    },
     // 职位大卡 START
    testHandleExposureJobList(jobList) {
      jobList.forEach(i => {
        if (!this.bigJobCardList.includes(i)) {
          this.bigJobCardList.push(i);
        }
      });
    },

  },
};
</script>
<style lang="less">
#app {
  .adapt_pc_widescreen & {
    background: #ffe8e1;
    height: auto;
  }
}
</style>
<style lang="less" scoped>
.activity-container {
  //padding-top: 244px;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 24px;
  position: relative;
  // padding-top: 30px;
  // & > div {
  //   position: relative;
  // }
  .scroll-tip {
    position: fixed;
    width: 44px;
    height: 44px;
    background: url("../assets/img/activity/btn_arrow_backtop.png") no-repeat
      center;
    background-size: 44px 44px;
    right: 15px;
    bottom: 98px;
    z-index: 3;
  }
  .bottom_tip {
    color: #4e4e4e;
    text-align: center;
    margin: 11px 0 0px 0;
    padding-bottom: 20px;
  }
  // .adapt_pc_widescreen & {
  //   width: 1200px;
  //   margin: 0 auto;
  // }
}
.show_bars{
  padding-bottom: 121px;
}
// 底部bar样式
.activity-bar {
  .van-popup{
    top: auto !important;
  }
  .van-popup--bottom{
    width: 100% !important;
    .pc & {
      width: 375px !important;
    }
  }
}
</style>
